<template>
  <v-select
    v-model="model"
    :options="options"
    label="name"
    :reduce="option => option.id"
    :placeholder="label"
    dir="rtl"
    :clearable="false"
    :value="value"
    @search="fetchOptions"
  />
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'SelectUser',
  components: {
    vSelect,
  },
  props: {
    name: {
      type: String,
      default: () => '',
    },
    label: {
      type: String,
      default: () => '',
    },
    value: {
      type: [String, Array, Number],
      default: () => '',
    },
    admin: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      options: [],
      model: '',
      timeout: null,
      debounce: 1,
    }
  },
  watch: {
    model: 'modelChange',
  },
  created() {
    if (this.value !== undefined && this.value !== null) {
      this.model = this.value
      this.getUsers({
        searched: true,
        ids: [this.value],
      })
    }
  },
  methods: {
    modelChange() {
      return this.$emit('onModelChange', this.name, this.model)
    },
    /**
       * Triggered when the search text changes.
       *
       * @param search  {String}    Current search text
       * @param loading {Function}	Toggle loading class
       */
    fetchOptions(search, loading = null) {
      if (search && search.length) {
        this.getUsers({ searched: true, search_key: search, admin: this.admin }, loading)
      }
    },
    getUsers(params, loading = null) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        if (loading) loading(true)
        this.$http.get('users', { params }).then(({ data }) => {
          this.options = data
          if (loading) loading(false)
        })
      }, this.debounce * 1000)
    },
  },
}
</script>

<style scoped>

</style>
